var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipForkKnife({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 7.31V12.79H15.93V8.85C15.93 8.7 15.88 7.53 14.75 7.31ZM14.75 7.31V12.79H15.93V8.85C15.93 8.7 15.88 7.53 14.75 7.31ZM12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM9.24 6.49H10.03V11.05H9.24V6.49ZM11.99 11.61C11.99 12.04 11.64 12.39 11.2 12.39H10.03V17.51H9.24V12.39H8.06C7.62 12.39 7.27 12.04 7.27 11.61V6.49H8.06V11.61H11.2V6.49H11.99V11.61ZM16.72 12.78C16.72 12.99 16.64 13.19 16.49 13.34C16.34 13.49 16.14 13.57 15.93 13.57H14.75V17.51H13.96V6.48H14.36C14.67 6.48 14.98 6.52 15.28 6.64C15.57 6.75 15.83 6.93 16.05 7.15C16.27 7.37 16.45 7.63 16.56 7.93C16.68 8.22 16.73 8.53 16.72 8.84V12.78ZM14.75 7.31V12.79H15.93V8.85C15.93 8.7 15.88 7.53 14.75 7.31Z",
    fill: "#99A1AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipForkKnife);
export default __webpack_public_path__ + "static/media/ic-chip-fork-knife.4f57806e5693bc38c9e04c9c80a9af76.svg";
export { ForwardRef as ReactComponent };